<template>
  <BaseModal
        :id="`${id ? id : 'upload-summary'}`"
        :title="`Upload Summary`"
        :size="'lg'"
        :message="message"
        @close="close($event)"
    >

        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>

        <template v-slot:content> 
            <export-excel
                v-show="error_summary.length"
                :data="error_data"
                :fields="error_headers"
                type="csv"
                :name="file_name !== undefined ? `${file_name}.csv` : 'template.csv'"
                v-html="label_items_fix"
            />
            
            <div class="w-100 table-responsive defaultproject__table overflow-y--2" v-show="error_summary.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, i) in summary_table_headers" :key="i" scope="col" v-html="item.name"/>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, i) in summary">
                            <template v-if="item.has_error">
                                <tr v-for="(error, j) in item.errors" :key="(j+i)">
                                    <td v-html="`Line Item #${(i+1)}`"/>
                                    <td v-html="error[0]"/>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'

export default {
    name: 'UploadSummary',

    props: [
        'breadcrumb',
        'summary',
        'excel_file_headers',
        'file_name',
        'excel_data',
        'id'
    ],

    components: {
        BaseModal,
        Breadcrumb,
    },

    data() {
        return {
            summary_table_headers: [
                { 
                    name:   'Line Item Number',
                },
                {   
                    name:   'Error',
                },
            ],
            label_items_fix: `<a href="#">Download file with incorrect items.</a>`,
        };
    },

    methods: {
       close(event) {
           this.$emit('close', event)
       }
    },

    computed: {

        message() { 
            const upload_success = this.summary.filter(item => !item.has_error).length
            return `The upload was completed with <a href="#">${upload_success} successfully imported items</a>.
            The items bellow could not be imported. Please review the errors and make the appropriate
            changes before trying again.`
        },

        error_data() {
            const errors = []

            this.summary.forEach((item, index) => {
                if(item.has_error) 
                {
                    let item_with_error = {...this.excel_data[index]}

                    let errorMessage = "";

                    if(item.errors)
                    {
                        Object.entries(item.errors).forEach(([key, errorArray], index) => {
                            if(key)
                            {
                                errorMessage += errorArray.join(" - ");
                                if (index !== Object.keys(item.errors).length - 1) 
                                {
                                    errorMessage += " - ";
                                }
                            }
                        })
                    }
                    


                    item_with_error['Errors'] = errorMessage
                    errors.push(item_with_error)
                }
            })

            return errors
        },

        error_summary() 
        {
            return this.summary.filter(item => item.has_error)
        },

        error_headers()
        {
            let error_headers = {...this.excel_file_headers};
            error_headers = Object.assign({Errors: 'Errors'}, error_headers);
            return error_headers;
        }
    }
}
</script>